import React from "react";

export const ShareListingPopupLazyComponent = React.lazy(() =>
  import("features/Listings/modules/ShareListingPopup/ShareListingPopup").then(
    (module) => ({
      default: module.ShareListingPopup,
    })
  )
);
